import React from 'react'

import { Col, InputNumber, Row } from 'antd'
import { useSelector } from 'react-redux'

import { selectTranslate } from '../../../../../reducers/LocaleReducer/LocalReducer'
import SectionsSelector from '../../../../shared/Selectors/SectionsSelector'
import SectionGroupsSelector from '../../../../shared/Selectors/SectionGroupsSelector'
import { isObject } from '../../../../../utils'
import { Properties } from '../../../../../utils/entities'

const PlaceAllocationForm = ({ disabled, quota, sections = [], sectionGroups = [], onChange }) => {
  const t = useSelector(selectTranslate)

  const handlePlacesChanging = places => {
    onChange(Number.isInteger(places) ? places : 0, Properties.TOTAL)
  }

  return (
    <div className='allocate-quota-form'>
      <Row>
        <Col span={12}>
          <h4><b>{t('allocation_form.places')}</b></h4>
        </Col>
        <Col span={12}>
          <InputNumber
            value={quota.total ?? 0}
            onChange={handlePlacesChanging}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <h4><b>{t('common.section_group')}</b></h4>
        </Col>
        <Col span={12}>
          <SectionGroupsSelector
            disabled={disabled || !!quota.section}
            empty
            multiple='default'
            sectionGroups={sectionGroups}
            style={{ width: '100%' }}
            values={isObject(quota.sectionGroup) ? quota.sectionGroup.id : null}
            onChange={(_v, _o, entity) => onChange(entity, Properties.SECTION_GROUP)}
          />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <h4><b>{t('common.section')}</b></h4>
        </Col>
        <Col span={12}>
          <SectionsSelector
            disabled={disabled || !!quota.sectionGroup}
            empty
            multiple='default'
            sections={sections}
            style={{ width: '100%' }}
            values={isObject(quota.section) ? quota.section.id : null}
            onChange={(_v, _o, entity) => onChange(entity, Properties.SECTION)}
          />
        </Col>
      </Row>
    </div>
  )
}

export default PlaceAllocationForm
